
<template>
  <el-row class="srm-product-info">
    <el-row class="bill-header">
      <el-col style="font-weight: 600" :span="16">产品信息</el-col>
      <el-col style="padding-left: 30px" :span="6">数量</el-col>
    </el-row>
    <el-row class="bill-info">
      <el-col :span="15" class="sample-info">
        <el-image
          v-if="infoData.mainImage"
          style="width: 50px; height: 50px; margin-right: 5px;"
          :src="infoData.mainImage + $ImgQuality30"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">
            加载中
          </div>
        </el-image>
        <div>
          <p>产品ID：{{ infoData.productId }}</p>
          <span style="word-break: break-all;" v-if="infoData.productName">{{ infoData.productName }}</span>
          <p v-if="infoData.capacity">
            容量：{{ infoData.capacity }}{{ infoData.capacityUnit || infoData.unit }}
          </p>
        </div>
      </el-col>
      <el-col class="input-num-box" :span="9">
        <el-input-number
          v-model="infoData.num"
          :min="1"
          :precision="0"
          :step="1"
          :disabled="isDisabled"
          :max="sampleVODetail.find(item => item.sampleType === infoData.sampleType).max"
        />
        <span class="sample-tooltip">{{ sampleUnit[infoData.sampleType] || '' }}</span>
        <span class="sample-tooltip-text">
          {{ sampleVODetail.find(item => item.sampleType === infoData.sampleType).typeName }}:
          {{ sampleVODetail.find(item => item.sampleType === infoData.sampleType).btnTips }}
        </span>
      </el-col>
    </el-row>
  </el-row>
</template>
<script>
import { sampleVODetail } from '@/utils/pageInfo';

export default {
  props: {
    listData: {
      type: Object,
      default() {
        return {};
      },
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    infoData: vm.listData,
    sampleUnit: {
      ODM: '份',
      PACKING_MATERIAL: '个',
      RAW_MATERIAL: 'g',
      MEMBRANE_CLOTH: '张',
    },
  }),
  computed: {
    sampleVODetail() {
      return sampleVODetail;
    },
  },
  watch: {
    listData: {
      handler(val) {
        return (this.infoData = val);
      },
    },
  },
  methods: {
    list() {
      return this.infoData;
    },
  },
};
</script>
<style lang="less" scoped>
.srm-product-info {
  width: 100%;
  background: #f3fbfe;
  .bill-header {
    border-bottom: 1px solid #cccccc50;
    line-height: 24px;
  }
  .bill-info {
    padding: 10px 0;
    .sample-info {
      display: flex;
      padding: 5px 0;
      img {
        margin-right: 10px;
      }
    }
    .input-num-box {
      position: relative;
      line-height: 60px;
    }
    .input-num {
      width: 100px;
    }
  }
  .sample-tooltip {
    position: absolute;
    left: 135px;
    top: 0;
    width: 35px;
    z-index: 1000;
  }
  .sample-tooltip-text {
    position: absolute;
    left: 0;
    top: 45px;
    z-index: 1000;
    font-size: 12px;
    line-height: 20px;
    color: #F56C6C;
  }
}
</style>
